module.exports = __webpack_public_path__ + "media/images/ecute/ecuteueno_ko_PC-9911f99a8d1c4d0ec85b076c480e1040.jpg";